module.exports = {
  title: 'python-工具端',
  storePrefix: '-',
  debug: true, // 是否是测试阶段
  appSecret: '1q2w3e*',
  // 是否开启超时判断
  isTimeout: true,
  // 正式版接口
  apiUrl: 'https://api.mamale.vip',
  // 测试版接口
  testApiUrl: 'https://api.mamale.vip',

}



// WEBPACK FOOTER //
// ./src/settings.js